import React from 'react';
import { IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ArrowBack = ({ history }) => {
	return (
		<IconButton onClick={history.goBack}>
			<ArrowBackIcon />
			返回
		</IconButton>
	);
};

export default ArrowBack;
